import { render } from "./RadioGroup.vue?vue&type=template&id=4044f644&scoped=true"
import script from "./RadioGroup.vue?vue&type=script&lang=js"
export * from "./RadioGroup.vue?vue&type=script&lang=js"

import "./RadioGroup.vue?vue&type=style&index=0&id=4044f644&lang=postcss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4044f644"]])